import { render } from "./ChartsPage.vue?vue&type=template&id=7a3c5fee&scoped=true"
import script from "./ChartsPage.vue?vue&type=script&lang=js"
export * from "./ChartsPage.vue?vue&type=script&lang=js"

import "./ChartsPage.vue?vue&type=style&index=0&id=7a3c5fee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3c5fee"]])

export default __exports__